module.exports = __webpack_public_path__ + "img/Logo.1b857c5e.svg";